import React, { ReactElement } from 'react';
import './Rules.scss';

const Ru: React.FC = (): ReactElement => {
  return (
    <div className="Ru">
      <h2>Правила кампании «БОЛЬШЕ ДОМАШНИХ МОМЕНТОВ»</h2>
      <ol>
        <li>
          Кампания <span className="bold">«БОЛЬШЕ ДОМАШНИХ МОМЕНТОВ»</span>{' '}
          является потребительской игрой (далее: кампания), проводимой с{' '}
          <span className="bold">01.02.2022</span> до{' '}
          <span className="bold">31.03.2022</span> Fazer Eesti OÜ (адрес: Пярну
          мнт., 158/1, Таллинн; далее: организатор).
        </li>
        <li>
          Состав призового фонда кампании: подарочные карточки магазина товаров
          для интерьера Kukupesa (5 шт., номинал 100€), кофемашина SMEG Espresso
          (1 шт., стоимость 399 €) и тостеры SMEG (3 шт., стоимость 159 €).
          Суммарная стоимость призового фонда: 1376 €.
        </li>
        <li>
          Порядок проведения кампании описан в настоящих правилах, составленных
          ее организатором. Все решения организатора в рамках проведения
          кампании являются окончательными и обязательными для всех участников
          кампании.
        </li>
        <li>
          Продукты в рамках кампании:{' '}
          <span className="bold">
            Kodusai suur 500g, Kodusai 300g, Kodusai Röst 500g, Kodusai Mini
            Röst 240g, Kodusai Minisaiake karamelliga 220g, Kodusai Minisaiake
            kaneeliga 220g, Kodusai Šokolaadi-kaneelisaiake 130g, Kodusai
            Kohupiimasaiake 130g
          </span>{' '}
          (далее: продукты).
        </li>
        <li>
          <ul>
            <li>
              Для участия в кампании следует приобрести по меньшей мере один
              товар Kodusai и зарегистрировать чек на сайте кампании:{' '}
              <a
                href="https://www.fazer.ee/kodusai"
                target="_blank"
                rel="noreferrer"
              >
                www.fazer.ee/kodusai
              </a>
              . Участвовать в кампании можно бесплатно. Для получения приза
              участник кампании должен предъявить ее организатору
              соответствующий чек.
            </li>
            <li>
              В рамках розыгрыша номер одного чека принимается только один раз.
              При неоднократной регистрации одного чека в розыгрыше участвует
              только первая его регистрация.
            </li>
            <li className="bold">Порядок обработки персональных данных</li>
            <li>
              Fazer Eesti OÜ обрабатывает полученные в рамках кампании
              персональные данные участника в соответствии с текущим
              законодательством Эстонской Республики и только для проведения
              кампании.
            </li>
            <li>
              Участник кампании разрешает Fazer Eesti OÜ обрабатывать
              предоставленные им данные в следующих целях:
            </li>
            <li>
              для подведения итогов кампании; для передачи информации связанным
              с проведением кампании деловым партнерам; для определения
              победителей и установления контакта с ними; для опубликования имен
              победителей на сайте кампании.
            </li>
            <li>
              Участники кампании имеют право получать дополнительную информацию
              об обработке их персональных данных Fazer Eesti OÜ. Для этого
              нужно отправить э-письмо:{' '}
              <a href="mailto:info@fazer.ee">info@fazer.ee</a>
            </li>
            <li>
              Ответственным обработчиком персональных данных является Fazer
              Eesti OÜ, регистровый код 10057691, Пярну мнт., 158/1, Таллинн
              11317; телефон 6502421;{' '}
              <a href="mailto:info@fazer.ee">info@fazer.ee</a>
            </li>
            <li>
              Собранные данные хранятся три месяца с даты окончания кампании, то
              есть до 01.07.2022. Полный список победителей размещается на сайте
              до 30.04.2021.
            </li>
          </ul>
        </li>
        <li>
          <ul>
            <li>Призы будут разыграны в следующие даты:</li>
            <li>
              08.02.2022 Будет разыграна 1 подарочная карта Kukupesa 100 €. В
              розыгрыше примут участие все регистрации, сделанные в период с
              01.02 00:00:00 до 07.02 23:59:59.{' '}
            </li>
            <li>
              22.02.2022 Будет разыграна 1 подарочная карта Kukupesa 100 €. В
              розыгрыше примут участие все регистрации, сделанные в период с
              08.02 00:00:00 до 21.02 23:59:59.{' '}
            </li>
            <li>
              08.03.2022 Будет разыграна 1 подарочная карта Kukupesa 100 €. В
              розыгрыше примут участие все регистрации, сделанные в период с
              22.02 00:00:00 до 07.03 23:59:59.
            </li>
            <li>
              22.03.2022 Будет разыграна 1 подарочная карта Kukupesa 100 €. В
              розыгрыше примут участие все регистрации, сделанные в период с
              08.03 00:00:00 до 21.03 23:59:59.{' '}
            </li>
            <li>
              01.04.2022 Будет разыграна 1 подарочная карта Kukupesa 100 €. В
              розыгрыше примут участие все регистрации, сделанные с 22.03
              00:00:00 до 31.03 23:59:59 31.03.
            </li>
            <li>
              01.04.2022 Среди всех участников кампании будет разыграна 1
              эспрессо-машина Smeg и 3 тостера Smeg. В розыгрыше примут участие
              все регистрации, сделанные в период с 01.02 00:00:00 до 31.03
              23:59:59.
            </li>
            <li>
              Представители организатора свяжутся c победителями по электронной
              почте или телефону, указанному в регистрационной форме.
            </li>
          </ul>
        </li>
        <li>
          Имена победителей будут опубликованы на сайте{' '}
          <a
            href="https://www.fazer.ee/kodusai"
            target="_blank"
            rel="noreferrer"
          >
            www.fazer.ee/kodusai{' '}
          </a>
          не позднее третьего рабочего дня после даты проведения розыгрыша.
          Представители организатора свяжутся с победителями для уточнения
          данных и вручения призов.
        </li>
        <li>
          Если победитель не соответствует условиям кампании или он не сохранил
          чек на покупку товара, номер которого он сообщил организатору через
          сайт кампании; также если с победителем не удалось связаться по
          предоставленным им контактным данным в течение двух недель после
          опубликования его имени на сайте{' '}
          <a
            href="https://www.fazer.ee/kodusai"
            target="_blank"
            rel="noreferrer"
          >
            www.fazer.ee/kodusai
          </a>
          , организатор имеет право не выдавать ему приз.
        </li>
        <li>
          Получивший от организатора любой приз победитель разрешает
          организатору использовать его имя в средствах массовой информации,
          рекламных материалах, общественных акциях и прочих мероприятиях без
          выплаты победителю дополнительных сумм и без заключения отдельного
          соглашения.
        </li>
        <li>
          Выигранные участниками кампании призы не подлежат замене по требованию
          победителей на иные призы или соответствующие денежные суммы, за
          исключением замены первоначального приза на равноценный приз по
          решению организатора.
        </li>
        <li>
          Связанные с вручением приза государственные налоги заплатит
          организатор в порядке и в сроки, предусмотренные законодательством.
        </li>
        <li>
          При нарушении участником кампании ее условий или предоставлении
          организатору неверной или неточной информации о себе, а также при
          возникновении иных проблем (организатор не смог связаться с
          победителем) не по вине организатора, организатор не несет
          ответственности за то, что соответствующий участник не смог принять
          участие в розыгрыше или получить приз.
        </li>
        <li>
          При возникновении обстоятельств непреодолимой силы (force majeure)
          организатор имеет право в одностороннем порядке прекратить проведение
          кампании и не разыгрывать призы и/или не вручать уже разыгранные призы
          победителям, сообщив об этом участникам кампании через средства
          массовой информации.
        </li>
        <li>
          Все связанные с кампанией разногласия подлежат урегулированию в
          соответствии с законодательством Эстонской Республики.
        </li>
        <li>
          Все связанные с организацией и/или проведением кампании претензии
          следует предъявлять в письменном виде по адресу организатора кампании:
          Pärnu maantee 158/1, 11317 Tallinn. Претензии должны иметь пометку
          «KAMPAANIA», и они принимаются до 01.04.2022. Предъявленные после
          вышеназванной даты претензии не рассматриваются. Ответ на поступившую
          претензию дается в течение 3 рабочих дней. Дополнительная информация о
          кампании: 650 2421; <a href="mailto:info@fazer.ee">info@fazer.ee</a>
        </li>
      </ol>
    </div>
  );
};

export default Ru;
